import { ComponentPropsWithoutRef, useContext } from 'react';
import { TableContext } from 'components/table/TableContext';
import { TablePageNavigation } from 'components/table/TablePageNavigation';
import { TablePerPageDropdown } from 'components/table/TablePerPageDropdown';
import { isTableEmpty } from 'components/table/util';
import { twMerge } from 'tailwind-merge';

interface TablePaginationRootProps extends ComponentPropsWithoutRef<'div'> {}

const TablePaginationRoot = (props: TablePaginationRootProps) => {
    const { className = '', children, ...rest } = props;
    const { table } = useContext(TableContext);

    if (isTableEmpty(table)) {
        return null;
    }

    return (
        <div
            className={twMerge(
                'relative flex flex-wrap items-center justify-center gap-2',
                className,
            )}
            {...rest}
        >
            {children}
        </div>
    );
};

const Root = TablePaginationRoot;
const PageNavigation = TablePageNavigation;
const PerPageDropdown = TablePerPageDropdown;

export {
    TablePaginationRoot,
    TablePageNavigation,
    TablePerPageDropdown,
    //
    Root,
    PageNavigation,
    PerPageDropdown,
};
